require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[4286],{

/***/ 2534:
/***/ ((module) => {

var amdi18n={"__root":{"selectOption":"Select an option"},"__cs":{"selectOption":"Vybrat volbu"},"__da":{"selectOption":"Vælg en indstilling"},"__de":{"selectOption":"Option auswählen"},"__es":{"selectOption":"Seleccionar una opción"},"__fi":{"selectOption":"Valitse jokin vaihtoehto"},"__fr":{"selectOption":"Sélectionner une option"},"__hr":{"selectOption":"Izaberite opciju"},"__hu":{"selectOption":"Válasszon ki egy beállítást"},"__it":{"selectOption":"Seleziona un'opzione"},"__ja":{"selectOption":"オプションの選択"},"__kk":{"selectOption":"Параметрді таңдаңыз"},"__ko":{"selectOption":"옵션 선택"},"__nb":{"selectOption":"Velg et alternativ"},"__nl":{"selectOption":"Selecteer een optie"},"__no":{"selectOption":"Velg et alternativ"},"__pl":{"selectOption":"Wybierz opcję"},"__pt":{"selectOption":"Selecione uma Opção"},"__pt-br":{"selectOption":"Selecione uma Opção"},"__ro":{"selectOption":"Selectaţi o opţiune"},"__ru":{"selectOption":"Выбрать опцию"},"__sl":{"selectOption":"Izbira možnosti"},"__sv":{"selectOption":"Välj ett alternativ"},"__th":{"selectOption":"เลือกอ็อพชัน"},"__tr":{"selectOption":"Bir Seçenek belirleyin"},"__uk":{"selectOption":"Виберіть варіант"},"__zh":{"selectOption":"选择选项"},"__zh-cn":{"selectOption":"选择选项"},"__zh-hk":{"selectOption":"選取選項"},"__zh-mo":{"selectOption":"選取選項"},"__zh-sg":{"selectOption":"选择选项"},"__zh-tw":{"selectOption":"選取選項"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 74712:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _baUiCarbon = __webpack_require__(6536);
__webpack_require__(79414);
var _StringResource = _interopRequireDefault(__webpack_require__(58319));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  BaPropTypes
} = _utils.propsUtils;
const DEFAULT_LABEL = _StringResource.default.get('selectOption');
class Select extends _react.PureComponent {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {});
    (0, _defineProperty2.default)(this, "toolkitOnChange", e => {
      const {
        onChange,
        options = []
      } = this.props;
      const {
        value
      } = e.target;
      const index = options.findIndex(o => String(o.value) === value);
      const option = options[index];
      onChange && onChange(option.value, option.label, index);
    });
  }
  render() {
    // destructuring unused props so that they can be ignored
    const {
      // removed - remapped
      /* eslint-disable react/prop-types */
      children,
      className,
      disabled,
      hideLabel,
      labelText,
      onChange,
      size,
      value,
      /* eslint-enable react/prop-types */
      // removed - deprecated
      active,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      customWidth = '100%',
      displayLabel,
      grouped,
      hover,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      icon,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      intent,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      label,
      options,
      readOnly,
      selected,
      showAllList,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      textDir,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      truncated,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      variableClassName,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      variant,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      // pass all other props to otherCarbonSelectProps
      ...otherCarbonSelectProps
    } = this.props;
    const {
      defaultValue
    } = this.props; // eslint-disable-line react/prop-types

    // remap className

    const mappedClassName = `${className != null ? className : ''} ba-toolkit-select-compat`;

    // remap disabled
    const mappedDisabled = disabled != null ? disabled : readOnly;

    // remap labelText
    const mappedLabelText = labelText != null ? labelText : label;

    // remap hideLabel
    const mappedHideLabel = (hideLabel != null ? hideLabel : mappedLabelText === undefined) ? true : undefined;

    // remap onChange
    const mappedOnChange = children ? onChange : this.toolkitOnChange;

    // remap size
    const mappedSize = size === 'small' ? 'sm' : size === 'normal' ? undefined : size;

    // remap value
    const mappedValue = value != null ? value : selected;

    // remap children / options
    let mappedChildren = children;
    if (!mappedChildren) {
      if (!grouped) {
        mappedChildren = (options || []).map(_ref => {
          let {
            label,
            ...otherSelectItemProps
          } = _ref;
          return /*#__PURE__*/_react.default.createElement(_baUiCarbon.SelectItem, (0, _extends2.default)({
            text: label
          }, otherSelectItemProps));
        });
      } else {
        // attempts to mimic toolkit grouped behavior in carbon
        mappedChildren = (options || []).reduce((groups, _ref2, i) => {
          let {
            label,
            group,
            ...otherSelectItemProps
          } = _ref2;
          const option = /*#__PURE__*/_react.default.createElement(_baUiCarbon.SelectItem, (0, _extends2.default)({
            text: label
          }, otherSelectItemProps));
          // if we don't have a group we push the option directly
          if (group == null) {
            groups.push(option);
          } else if (i === 0 || group !== options[i - 1].group) {
            // if it's our first entry or we've entered a new group
            groups.push(group ? /*#__PURE__*/_react.default.createElement(_baUiCarbon.SelectItemGroup, {
              label: group
            }, option) : option);
          } else {
            // otherwise we're in the same group, add the option to the children of the previous group
            const element = groups[groups.length - 1];
            groups[groups.length - 1] = _react.default.cloneElement(element, {
              children: [..._react.default.Children.toArray(element.props.children), option]
            });
          }
          return groups;
        }, []);
      }
    }

    // Adding a DEFAULT_LABEL entry to the mappedChildren if one does not already exist and one is needed.
    // This is non-Carbon.
    // Carbon expects clients to fill out all the children(CarbonSelectItem) nodes.
    if (this.state.defaultSelectItem) {
      // If we've injected a default option, continue to inject it.
      // Changing the number of CarbonSelectItems leads to mismatched IDs -> Items in the select.
      mappedChildren.unshift(this.state.defaultSelectItem);
    } else {
      const defaultOption = defaultValue != null ? defaultValue : mappedValue;
      if (!children && (!defaultOption || (options || []).every(o => o.value !== defaultOption))) {
        /*
         * In order to mimic old functionality, we create a hidden option with
         * content of as the text and bogus '__displayLabel__' as the value.
         * The option is inserted at the beginning of the options.
         * Since the option is hidden, it can never be selected, but visually achieves
         * the trick of a display label (e.g. 'Select an option').  Consumers may need to revisit down the
         * road and support this by supplying their own 'display label' as part of the 'options'.
         */
        const defaultSelectItem = /*#__PURE__*/_react.default.createElement(_baUiCarbon.SelectItem, {
          value: defaultOption != null ? defaultOption : '__displayLabel__',
          text: displayLabel != null ? displayLabel : DEFAULT_LABEL,
          hidden: true
        });
        // insert at beginning, if no defaultOption set first entry is always shown
        mappedChildren.unshift(defaultSelectItem);

        // If we've injected a default option, save it in case it needs to be injected later.
        // Changing the number of CarbonSelectItems leads to mismatched IDs -> Items in the select.
        this.setState({
          defaultSelectItem
        });
      }
    }

    // Carbon Select does not honor the style={{ width: 'someWidth' }} prop
    // To address this we need to apply width to a few spots within the Carbon Select widget.
    // This is really hokey.
    // Carbon bug: https://github.com/carbon-design-system/carbon/issues/7259
    //
    // <div class="bx-form-item" >
    // 	// need to apply width="100%" to this div to stretch the select to match its parents width (done in the scss file)
    // 	<div class="bx--select ba-toolkit-select-compat">
    // 		<label>
    // 		// need to apply width="customWidth" to this div to make select the size the user wants (done here, apply to parent of bx--select-input)
    // 		<div class="bx--select-input__wrapper" >
    // 			// need to apply width="100%" and min-width="100%" to this select to stretch/shrink the select contents (done in the scss file)
    // 			<select class="bx--select-input"
    // 			<svg

    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.Select, (0, _extends2.default)({}, otherCarbonSelectProps, {
      className: mappedClassName,
      disabled: mappedDisabled,
      hideLabel: mappedHideLabel,
      labelText: mappedLabelText,
      onChange: mappedOnChange,
      ref: el => {
        el && el.parentNode.style.setProperty('width', customWidth);
      },
      size: mappedSize,
      value: mappedValue
    }), mappedChildren);
  }
}
exports["default"] = Select;
(0, _defineProperty2.default)(Select, "propTypes", {
  /** Deprecated (not applicable to Carbon Select): Passed as a prop to Select Button component */
  active: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),
  /** deprecated - set style={width: 'in px or %', min-width: 'in px or %'} */
  customWidth: BaPropTypes.deprecated('deprecated - set style={width: "in px or %", min-width: "in px or %"}'),
  disabled: _propTypes.default.bool,
  /** deprecated - no Carbon option */
  displayLabel: BaPropTypes.deprecated('deprecated - no Carbon option'),
  /** deprecated - supply children nested using the Carbon <SelectItemGroup> component */
  grouped: BaPropTypes.deprecated('deprecated - supply children nested using the Carbon <SelectItemGroup> component'),
  /** Deprecated (not applicable to Carbon Select): Passed as a prop to Select Button component */
  hover: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),
  /** Deprecated (not applicable to Carbon Select): Icon diplayed inside the Select box */
  icon: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),
  /** Deprecated (not applicable to Carbon Select): Sets the intent for Select box (Passed as a prop to Button component) */
  intent: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),
  /** Deprecated: Label displayed at the top of Select. Use the carbon prop 'labelText' */
  label: BaPropTypes.deprecated(' is deprecated, use the carbon prop labelText'),
  /** deprecated(sort of) - used as Toolkit prop returns a non-standard signature(value,label,index), used as Carbon prop returns standard signature(event). If options are childern = Carbon, else toolkit. */
  onChange: BaPropTypes.deprecated('deprecated(sort of) - used as Toolkit prop returns a non-standard signature(value,label,index), used as Carbon prop returns standard signature(event). If options are childern = Carbon, else toolkit.'),
  /** deprecated - pass menu items as children. As a toolkit prop Items can be grouped using 'group' prop. Note: grouped prop should be set to true to make grouping work */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    group: _propTypes.default.any,
    value: _propTypes.default.any.isRequired,
    label: _propTypes.default.string.isRequired
  })).isRequired,
  /** deprecated - no Carbon option(maybe disabled) */
  readOnly: BaPropTypes.deprecated('deprecated - no Carbon option(maybe disabled)'),
  /** deprecated - use value; if defining a default option ===IN CARBON THE CLIENT MUST ADD THE DEFAULT(undefined) "Select an option" ENTRY TO ITS CHILDREN=== */
  selected: BaPropTypes.deprecated('deprecated - use value; if defining a default option ===IN CARBON THE CLIENT MUST ADD THE DEFAULT(undefined) "Select an option" ENTRY TO ITS CHILDREN==='),
  /** Deprecated (not applicable to Carbon Select): Display the entire list of items without the scrollbar */
  showAllList: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),
  /** Deprecated (not applicable to Carbon Select): Text direction */
  textDir: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),
  /** Deprecated (not applicable to Carbon Select): If set to true, dropdown items texts will be truncated */
  truncated: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),
  /** Deprecated (not applicable to Carbon Select): Variable class names */
  variableClassName: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),
  /** Deprecated (not applicable to Carbon Select): Sets the variant for Select box (Passed as a prop to Button component) */
  variant: BaPropTypes.deprecated(' is ignored and not applicable to carbon select')
});
(0, _defineProperty2.default)(Select, "__Select__", true);

/***/ }),

/***/ 82537:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _Select = _interopRequireDefault(__webpack_require__(74712));
exports["default"] = _Select.default;
exports.Select = _Select.default;

/***/ }),

/***/ 58319:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _utils = __webpack_require__(78815);
var _SelectResources = _interopRequireDefault(__webpack_require__(2534));
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = exports["default"] = new _utils.StringResource(_SelectResources.default);

/***/ }),

/***/ 87209:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-toolkit-select-compat{width:100%}.ba-toolkit-select-compat .bx--select-input{width:100%;min-width:100%}", ""]);

// exports


/***/ }),

/***/ 79414:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Select_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87209);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Select_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Select_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Select_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Select_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Select_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Select_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Select_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Select_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 6536:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(82537));
/******/ return __webpack_exports__;
/******/ }
]);
});